// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"546":"ec5880f4","811":"a651884c"}[chunkId] + ".chunk.css";
};